/* ConvertMate 24-oct-2026 · <cm-filtros>: chips que filtran tarjetas (cm-testimonios, cm-productos).
   Chips: <button data-cm-filtro="clave" aria-pressed>. Items: [data-cm-item data-cm-claves="a,b"]. Clave "" = todos. */
if (!customElements.get('cm-filtros')) {
  customElements.define('cm-filtros', class extends HTMLElement {
    connectedCallback() {
      this.chips = Array.from(this.querySelectorAll('[data-cm-filtro]'));
      this.items = Array.from(this.querySelectorAll('[data-cm-item]'));
      this.live = this.querySelector('[data-cm-live]');
      this.chips.forEach((c) => c.addEventListener('click', () => this.aplicar(c)));
    }
    aplicar(chip) {
      const clave = (chip.getAttribute('data-cm-filtro') || '').trim().toLowerCase();
      this.chips.forEach((c) => c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'));
      let n = 0;
      this.items.forEach((it) => {
        const claves = (it.getAttribute('data-cm-claves') || '').toLowerCase().split(',').map((s) => s.trim());
        const ok = !clave || claves.indexOf(clave) > -1;
        it.hidden = !ok;
        if (ok) n++;
      });
      const scroller = this.querySelector('[data-cm-scroller]');
      if (scroller) scroller.scrollTo({ left: 0, behavior: 'smooth' });
      const vacio = this.querySelector('[data-cm-vacio]');
      if (vacio) vacio.hidden = n > 0;
      if (this.live) this.live.textContent = n + ' resultados';
    }
  });
}
